import FilterHeader from "./FilterHeader";
import FilterListItems from "./FilterListItems";
import { useState } from "react";
import InputContainer from "../../../common/InputContainer";
import Container from "../../../common/Container";
import BlueToggle from "../../../common/BlueToggle";
import { useTranslation } from "react-i18next";

const FilterManagement = ({
    filters,
    createFilter,
    setNewFilterInput,
    loading,
    createFilterMessage,
    filterAddButtonClass,
    handelKeyPress,
    newFilterInput,
    updateProfanityFilter,
    deleteProfanityFilter,
}) => {
    const { t } = useTranslation("profanityPage");
    const [toggleBlurState, setToggleBlurState] = useState(false);
    const [inputContainerFilterClass, setInputContainerFilterClass] = useState(
        "inputContainerFilterBlur",
    );

    const onFilterToggleClick = () => {
        setToggleBlurState(!toggleBlurState);

        if (inputContainerFilterClass === "inputContainerFilterBlur")
            setInputContainerFilterClass("inputContainerFilterShow");
        else if (inputContainerFilterClass === "inputContainerFilterShow")
            setInputContainerFilterClass("inputContainerFilterBlur");
    };

    let content = (
        <>
            <>
                <FilterHeader />
                {loading ? <p>{t("loadingFilters")}</p> : ""}
            </>
            <div className="filterContainerToggleBlur">
                <BlueToggle
                    title={t("showFilters")}
                    onToggle={onFilterToggleClick}
                    state={toggleBlurState}
                />
            </div>

            <p className="filterInfoNumberDisplay">
                {t("activeFilters", { filters: `[ ${filters.length} ]` })}
            </p>

            <div>
                <InputContainer
                    onInput={(e) => setNewFilterInput(e.target.value)}
                    placeholder={t("createFilterPlaceHolder")}
                    buttonText={t("addButtonFilter")}
                    buttonIsGray={filterAddButtonClass}
                    buttonOnClick={createFilter}
                    messageText={createFilterMessage}
                    arrayObject={filters}
                    content={
                        <FilterListItems
                            filters={filters}
                            inputContainerFilterClass={
                                inputContainerFilterClass
                            }
                            updateProfanityFilter={updateProfanityFilter}
                            deleteProfanityFilter={deleteProfanityFilter}
                        />
                    }
                    onKeyPress={handelKeyPress}
                    value={newFilterInput}
                />
            </div>
        </>
    );

    return (
        <Container content={content} isNoBackground={true} noAnimation={true} />
    );
};

export default FilterManagement;
